import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './result.css';

const Result = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const [results, setResults] = useState({
    nameMatch: null,
    oldCompanyMatch: null,
    phoneMatch: null
  });

  const [userInfo, setUserInfo] = useState({
    username: '',
    fileName: '',
    processTime: ''
  });

  useEffect(() => {
    // ✅ Đọc từ localStorage thay vì location.state
    const uploadResults = localStorage.getItem('uploadResults');

    if (!uploadResults) {
      console.error('❌ Không tìm thấy dữ liệu upload trong localStorage');
      setLoading(false);
      return;
    }

    try {
      const state = JSON.parse(uploadResults);
      console.log('📋 Dữ liệu từ localStorage:', state);

      const username = sessionStorage.getItem('username') || state.personalInfo?.fullName || 'N/A';
      const fileName = state?.uploadedFiles?.[0]?.name || 'Chưa có file';
      const cccdId = state?.personalInfo?.cccdId;

      setUserInfo({
        username,
        fileName,
        processTime: new Date().toLocaleString('vi-VN')
      });

      setLoading(true);

      if (cccdId) {
        console.log('🔍 Gọi API với CCCD:', cccdId);

        fetch('https://vss.inv.eeekyc.site/api/v1/vss/check-info', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': 'gKgjO6thPE5Dyfk6LXnIKPYuSJk3pO8o'
          },
          body: JSON.stringify({ card_id: cccdId })
        })
          .then(res => res.json())
          .then(data => {
            console.log('📡 API Response:', data);

            const vss = data?.data?.vss;
            const timeline = data?.data?.timeline;

            const personalInfo = state?.personalInfo;

            const fullName = vss?.full_name || '';
            const phone = vss?.phone_no?.[0] || '';

            let newestCompany = null;
            let companyTaxNo = '';
            if (timeline?.length > 0) {
              newestCompany = timeline.reduce((latest, current) => {
                return +current.set_period_weeks > +latest.set_period_weeks ? current : latest;
              }, timeline[0]);
              companyTaxNo = newestCompany?.company_tax_no || '';
            }

            console.log('📌 Thông tin từ VSS:');
            console.log('  - fullName:', fullName);
            console.log('  - phone:', phone);
            console.log('  - companyTaxNo:', companyTaxNo);

            console.log('📌 Thông tin từ form:');
            console.log('  - fullName:', personalInfo?.fullName);
            console.log('  - phone:', personalInfo?.phoneNumber);
            console.log('  - companyTaxCode:', personalInfo?.companyTaxCode);

            let nameMatch = null;
            let phoneMatch = null;
            let oldCompanyMatch = null;

            const rawResult = data?.data?.vss_result || state?.apiResults?.[0]?.[0]?.result;

            // ✅ Kiểm tra rawResult và xử lý
            if (rawResult && typeof rawResult === 'object') {
              Object.values(rawResult).forEach(result => {
                console.log('🔍 Processing:', { key: result.key, code: result.code, answer: result.answer });

                if (result.key === 'have_name') {
                  if (result.code == 0) {
                    const vssName = fullName.trim().toLowerCase();
                    const formName = personalInfo?.fullName?.trim().toLowerCase();
                    nameMatch = vssName === formName;
                    console.log(`✅ Name check: "${vssName}" === "${formName}" = ${nameMatch}`);
                  } else {
                    nameMatch = null;
                    console.log('❌ Name check skipped (code != 0)');
                  }
                }

                if (result.key === 'have_old_staff') {
                  if (result.code == 0) {
                    const vssCompany = companyTaxNo.trim();
                    const formCompany = personalInfo?.companyTaxCode?.trim();
                    oldCompanyMatch = vssCompany === formCompany;
                    console.log(`✅ Company check: "${vssCompany}" === "${formCompany}" = ${oldCompanyMatch}`);
                  } else {
                    oldCompanyMatch = null;
                    console.log('❌ Company check skipped (code != 0)');
                  }
                }

                if (result.key === 'have_phone') {
                  if (result.code == 0) {
                    const vssPhone = phone.trim();
                    const formPhone = personalInfo?.phoneNumber?.trim();
                    phoneMatch = vssPhone === formPhone;
                    console.log(`✅ Phone check: "${vssPhone}" === "${formPhone}" = ${phoneMatch}`);
                  } else {
                    phoneMatch = null;
                    console.log('❌ Phone check skipped (code != 0)');
                  }
                }
              });
            } else {
              console.warn('⚠️ rawResult is not valid:', rawResult);
            }

            const newResults = { nameMatch, oldCompanyMatch, phoneMatch };
            console.log('✅ Final results:', newResults);
            setResults(newResults);
            setLoading(false);
          })
          .catch(err => {
            console.error('❌ Lỗi gọi API check-info:', err);
            setLoading(false);
          });
      } else {
        console.error('❌ Không có CCCD ID');
        setLoading(false);
      }
    } catch (error) {
      console.error('❌ Lỗi parse localStorage:', error);
      setLoading(false);
    }
  }, []);

  const renderStatus = (status) => {
    if (loading) return <span className="status-pending">Đang xử lý...</span>;
    if (status === null) return <span className="status-pending">Không xử lý</span>;
    return status
      ? <span className="status-yes">Khớp</span>
      : <span className="status-no">Không khớp</span>;
  };
  const handleBackToUpload = () => navigate('/upload-file');
  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };
  const handleRefresh = () => {
    setResults({
      nameMatch: Math.random() > 0.5,
      oldCompanyMatch: Math.random() > 0.5,
      phoneMatch: Math.random() > 0.5
    });
  };

  return (
    <div className="result-app">
      <div className="result-container">
        <div className="result-header">
          <h1>Kết quả xác minh</h1>
          <div className="user-info">
            <span>Người dùng: {userInfo.username}</span>
            <span>Thời gian: {userInfo.processTime}</span>
          </div>
        </div>

        <div className="result-content">
          <div className="file-info">
            <h3>Thông tin file đã xử lý</h3>
            <p>Tên file: <strong>{userInfo.fileName}</strong></p>
          </div>

          <div className="verification-results">
            <h3>Kết quả xác minh</h3>

            <div className="result-item">
              <div className="result-label"><i className="icon-user"></i>ID khớp với tên:</div>
              {renderStatus(results.nameMatch)}
            </div>

            <div className="result-item">
              <div className="result-label"><i className="icon-company"></i>ID liên quan đến mã số thuế công ty mới nhất:</div>
              {renderStatus(results.oldCompanyMatch)}
            </div>

            <div className="result-item">
              <div className="result-label"><i className="icon-phone"></i>ID khớp với số điện thoại:</div>
              {renderStatus(results.phoneMatch)}
            </div>
          </div>
        </div>

        <div className="result-actions">
          <button onClick={handleBackToUpload} className="btn-secondary">
            <i className="icon-upload"></i> Upload file khác
          </button>
          <button onClick={handleLogout} className="btn-danger">
            <i className="icon-logout"></i> Đăng xuất
          </button>
        </div>
      </div>
    </div>
  );
};

export default Result;